import { MdOutlineIntegrationInstructions } from 'react-icons/md';
import { ChatControllerBaseConfig } from '../../../../base';
import { SolutionContextItemController } from './solutionContextInterface';

export function createSolutionContextItemController(
    config: ChatControllerBaseConfig
): SolutionContextItemController {
    return {
        useProps(context, item, props) {
            return {
                item: {
                    type: {
                        label: 'Solution',
                    },
                    label: item.solution.name,
                    description: item.solution.description,
                    tooltip: {
                        label: item.solution.tagline,
                    },
                    Icon: MdOutlineIntegrationInstructions,
                    remove: {
                        button: {
                            onClick() {
                                props.onRemove();
                            },
                        },
                    },
                },
            };
        },
    };
}
